import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/hooks/useCompany";
import { useMenu } from "@/hooks/useMenu";
import { As400Menu } from "@/components/layout/As400Menu";

const KEY = "bc-menu-pos";
const posSalvate = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; } };
export const salvaPos = (livello, idx) => {
  const p = { ...posSalvate(), [livello]: idx };
  sessionStorage.setItem(KEY, JSON.stringify(p));
};
export const leggiPos = (livello) => posSalvate()[livello] ?? 0;

export default function HomeMenu() {
  const { user } = useAuth();
  const company = useCompany();
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const { areas } = useMenu(user);
  const areaKey = params.get("area");
  const area = useMemo(() => areas.find((a) => a.key === areaKey), [areas, areaKey]);
  const livello = area ? `area:${area.key}` : "main";
  const [sel, setSel] = useState(() => leggiPos(livello));

  useEffect(() => { setSel(leggiPos(livello)); }, [livello]);

  const seleziona = (i) => { setSel(i); salvaPos(livello, i); };

  const rows = area
    ? area.items.map((i) => ({ key: i.to + i.testid, label: i.label, tone: area.tone, testid: i.testid }))
    : areas.map((a) => ({ key: a.key, label: a.title, tone: a.tone, testid: `menu-area-${a.key}` }));

  const apri = (i) => {
    if (area) { salvaPos(livello, i); nav(area.items[i].to); return; }
    salvaPos("main", i);
    setParams({ area: areas[i].key });
  };

  const esci = () => { if (area) setParams({}); };

  return (
    <div className="min-h-[calc(100vh-9rem)] flex items-start lg:items-center justify-center py-0 lg:py-4"
      data-testid="home-menu">
      <As400Menu
        testid={area ? `as400-submenu-${area.key}` : "as400-main-menu"}
        title={area ? area.title : "Menu Principale"}
        subtitle={area
          ? "Selezionare la funzione desiderata e premere INVIO"
          : `${company.name || "BENEDETTA CARNI"} · Gestionale aziendale — selezionare l'area e premere INVIO`}
        rows={rows}
        selected={Math.min(sel, Math.max(rows.length - 1, 0))}
        onSelect={seleziona}
        onOpen={apri}
        onExit={esci}
      />
    </div>
  );
}
